/* eslint-disable default-param-last */
/* eslint-disable import/no-mutable-exports */
import { WasmVersion } from './types';

export let apiUrl = process.env.REACT_APP_API_URL;
export let orchestrationAPIUrl = process.env.REACT_APP_API_ORCHESTRATION;
export let orchestrationApiKey = process.env.REACT_APP_API_ORCHESTRATION_API_KEY;
export let apiKey = process.env.REACT_APP_API_KEY;
export let wasmUrl: string = process.env.REACT_APP_API_URL_WASM || process.env.REACT_APP_API_URL;
export let wasmModule = (process.env.REACT_APP_WASM_MODULE as WasmVersion) || WasmVersion.face_mask;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export let cacheConfig = process.env.REACT_APP_SET_CACHE ? JSON.parse(process.env.REACT_APP_SET_CACHE) : true;

export const setEnvVariables = (
  api_key: string | null,
  api_url: string | null = null,
  api_orchestration_url: string | null = null,
  wasm_url: string | null = null,
  wasm_module: WasmVersion | null = null,
  cache_config: boolean,
  api_orchestration_api_key: string | null = null,
) => {
  console.log({envVariables: process.env})
  if (api_key) {
    apiKey = api_key;
  }
  if (api_url) {
    apiUrl = api_url;
  }
  if (api_orchestration_url) {
    orchestrationAPIUrl = api_orchestration_url;
  }
  if (wasm_url) {
    wasmUrl = wasm_url;
  } else if (!wasm_url && !wasmUrl && apiUrl) {
    wasmUrl = apiUrl;
  }
  if (wasm_module) {
    wasmModule = wasm_module;
  }
  if (cache_config) {
    cacheConfig = cache_config;
  }
  if (api_orchestration_api_key) {
    orchestrationApiKey = api_orchestration_api_key;
  }
};
